module.exports = __webpack_public_path__ + "img/board2-GPX-blue-white-52.c1066883.jpg";